import React, { useState, useEffect } from 'react';

/**
 * <img> 를 그대로 쓰면, 이미지 로드가 실패했을 때(파일 삭제됨, 404 등) 브라우저마다
 * "엑박" 아이콘 + alt 텍스트를 다르게 렌더링해서 지정한 width/height 를 무시하고
 * 박스 크기가 달라지는 경우가 있다 (목록 레이아웃이 들쭉날쭉해지는 원인).
 *
 * 이 컴포넌트는 로드 실패를 감지(onError)해서, 실패 시 이미지 대신 완전히 동일한
 * 크기의 빈 박스(placeholder)를 렌더링한다 - 성공하든 실패하든 차지하는 공간이
 * 항상 같아서 레이아웃이 절대 깨지지 않는다. src 가 아예 없을 때도 같은 placeholder 를 쓴다.
 */
export default function ImageWithFallback({ src, alt = '', className = '', style = {} }) {
  const [failed, setFailed] = useState(false);

  // 같은 컴포넌트 인스턴스가 재사용되며 src 만 바뀌는 경우(리스트 정렬 변경 등)
  // 이전 실패 상태가 남아있지 않도록 초기화한다.
  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return <div className={className} style={{ ...style, background: 'var(--color-bg)' }} aria-label={alt} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}
